import { useState, useEffect } from "react";

export function useA2HS() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        function handleBeforeInstallPrompt(e) {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        }

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    }, []);

    const installApp = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const choice = await deferredPrompt.userChoice;

        if (choice.outcome === "accepted") {
            console.log("Installing...");
            // save to local storage that user has installed
            localStorage.setItem("pwa-installed", "true");
        } else {
            console.log("Install declined");
        }

        setDeferredPrompt(null);
        setIsInstallable(false);
    };

    return { isInstallable, installApp };
}

// Check if the app is in "app" mode
export function isInStandaloneMode() {
    // iOS
    if ('standalone' in navigator && navigator.standalone) {
        return true;
    }

    // Chrome / Edge
    if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }

    return false;
}

// Check if user has installed the PWA before
export function isInstalledPWA() {
    var isInstalled = localStorage.getItem("pwa-installed");
    if (isInstalled === null) return false;
    return isInstalled === "true";
}